import { formatDate } from 'containers/phoenix/utils/dateUtils';
import { getPhoenixFlavouredDimension } from 'containers/phoenix/data/dimensions/dimensionsParser';

export const getMetricsPayload = (inputData, type, dimensions, metrics) => {
	if (type === 'PhoenixTimeSeries') {
		return getTimeSeriesPayload(inputData, dimensions, metrics);
	}
	return getTimePeriodPayload(inputData, dimensions, metrics);
};

const getTimePeriodPayload = (inputData, dimensions, metrics) => {
	const { metricsList, timeperiods } = getMetricsAndTimeperiods(
		metrics.xdeMetricsOrder,
		inputData,
	);
	const v2Body = {
		request: {
			settings: {
				includeTotal: true,
				includeSubTotal: true,
			},
			performanceObject: getPerformanceObject(inputData),
			breakdown: getBreakdowns(inputData, dimensions),
			overrides: [],
			filters: [],
			metrics: metricsList,
			timeSeries: null,
			timePeriod: {
				endDate: formatDate(inputData.referancedate.text, 'yyyy-mm-dd'),
				periods: timeperiods,
				customPeriods: null,
			},
		},
	};
	return v2Body;
};

const getTimeSeriesPayload = (inputData, dimensions, metrics) => {
	// const metrics = ["RateOfReturn"];
	const { metricsList, timeperiods } = getMetricsAndTimeperiods(
		metrics.xdeMetricsOrder,
		inputData,
		false,
	);
	const v2Body = {
		request: {
			settings: {
				includeTotal: true,
				includeSubTotal: false,
			},
			performanceObject: getPerformanceObject(inputData),
			breakdown: getBreakdowns(inputData, dimensions),
			overrides: [],
			filters: [],
			metrics: metricsList,
			timeSeries: {
				startDate: formatDate(inputData.startdate.text, 'yyyy-mm-dd'),
				endDate: formatDate(inputData.enddate.text, 'yyyy-mm-dd'),
				frequency: inputData.frequency.text,
			},
			timePeriod: null,
		},
	};
	return v2Body;
};

const getPerformanceObject = inputData => {
	const sponsorSID =
		!inputData.analysisLevel || inputData.analysisLevel.key !== 'Hierarchy'
			? inputData.accountId.map(a => a.accountBusinessID)
			: [inputData.hierarchy.level1GroupID];
	const type =
		!inputData.analysisLevel || inputData.analysisLevel.key !== 'Hierarchy'
			? 'Account'
			: 'AccountGroup';
	const fee = inputData.fee.key;
	return {
		sid: sponsorSID,
		type,
		categoryFilter: fee,
		tag: 'portfolio',
	};
};

const getBreakdowns = (inputData, dimensions) => {
	const cubeDimensions = getPhoenixFlavouredDimension(
		dimensions.xdeDimensionOrder,
		inputData.analysisLevel,
		inputData.hierarchyLevel,
	);
	if (
		!inputData.analysisLevel ||
		inputData.analysisLevel.key !== 'Hierarchy'
	) {
		const includesGICSOnly = cubeDimensions
			.map(item => item.column)
			.every(item => item.includes('GICS'));
		return {
			expand: 'AccountsOnly',
			benchmarkOption: inputData.benchmark.benchmarkUsage,
			copyTotalBenchmarkToChildNodes: false,
			benchmarkDecompositionType: includesGICSOnly
				? 'Primary'
				: 'Constituents',
			cubeDimensions,
		};
	}
	const breakdowns = {
		expand:
			inputData?.hierarchyLevel?.key === 'All Levels'
				? 'ALL'
				: 'AccountsOnly',
		benchmarkOption: 'None',
		cubeDimensions: getHierarchyCubeDimensions(
			inputData.hierarchyLevel.key,
			cubeDimensions,
		),
	};
	if (inputData?.hierarchyLevel?.key === 'Custom Dimensions') {
		delete breakdowns.expand;
	}
	return breakdowns;
};

const getHierarchyCubeDimensions = (hierarchyLevel, cubeDimensions) => {
	return hierarchyLevel !== 'Accounts Only'
		? cubeDimensions
		: [
			{
				name: 'Account',
				column: 'AccountBusinessID',
			},
		  ];
};

export const getMetricsAndTimeperiods = (xdeMetrics, inputData, isTP = true) => {
	const metricsList = [];
	const timeperiods = [];
	xdeMetrics.map(metric => {
		const combined = metric.colId.split('|');
		combined[0] ? metricsList.push(combined[0]) : null;
		if (isTP) { 
			combined[1] && combined[1] !== '' && combined[1] !== 'undefined'
			? timeperiods.push(combined[1])
			: null;
		}
	});
	if (isTP && inputData?.benchmark?.benchmarkUsage !== 'None') {
		metricsList.push('ObjectName');
	}
	return {
		metricsList: [...new Set(metricsList)],
		timeperiods: [...new Set(timeperiods)],
	};
};
